var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imgsrc)?_c('router-link',{staticClass:"logo block",attrs:{"to":_vm.link ? _vm.link : '/'}},[_c('img',{attrs:{"src":_vm.imgsrc,"alt":"Logo"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }